import { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@brent/core-ui/ui'
import { Button } from '@brent/core-ui/ui'
import { Plus } from 'lucide-react'
import { SuggestionForm } from '@brent/core-ui/components'
import { useCreateSuggestion } from '@/hooks/useSuggestions'
import { searchComposers, getComposerWorks } from '@/services/api/wikidata'
import type { SuggestionFormData } from '@brent/shared/validation'

interface CreateSuggestionDialogProps {
  className?: string
}

export const CreateSuggestionDialog = ({ className }: CreateSuggestionDialogProps) => {
  const [open, setOpen] = useState(false)
  const createMutation = useCreateSuggestion()

  const handleSubmit = async (data: SuggestionFormData) => {
    try {
      await createMutation.mutateAsync(data)
      setOpen(false)
    } catch (error) {
      // Error will be displayed by the form
      console.error('Failed to create suggestion:', error)
    }
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className={className}>
          <Plus className="mr-2 h-4 w-4" />
          Suggest a Piece
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Suggest a Piece</DialogTitle>
          <DialogDescription>
            Suggest a piece you'd like the orchestra to play. Include the composer's name and the
            piece title.
          </DialogDescription>
        </DialogHeader>
        <SuggestionForm
          onSubmit={handleSubmit}
          onCancel={() => setOpen(false)}
          isLoading={createMutation.isPending}
          submitLabel="Create Suggestion"
          searchComposers={searchComposers}
          searchWorks={getComposerWorks}
        />
      </DialogContent>
    </Dialog>
  )
}
